import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

// Mock client to prevent crash if credentials are missing
const mockSupabase = {
  from: () => ({
    insert: async () => ({ error: null }),
    select: async () => ({ data: [], error: null }),
  }),
};

export const supabase = (supabaseUrl && supabaseAnonKey)
  ? createClient(supabaseUrl, supabaseAnonKey)
  : mockSupabase;

if (!supabaseUrl || !supabaseAnonKey) {
  console.warn('Supabase credentials missing. Using mock client.');
}

export const sendContactMessage = async ({ name, email, subject, message }) => {
  try {
    const { error } = await supabase
      .from('contact_messages')
      .insert([{ name, email, subject, message }]);
    if (error) throw error;
  } catch (err) {
    console.error('Supabase Error:', err.message || err);
    throw err;
  }
};

export const logVisit = async () => {
  await supabase.from('page_visits').insert([{ page: 'portfolio' }]);
};
